import { useMutation } from "@tanstack/react-query";
import apiClient from "../client";

/**
 * Publishes to the Back Office and keeps nothing here, so there is no query to invalidate and nothing
 * for the portal to read back. Same contract as the feedback hooks: the customer is told it landed.
 */

export interface RequestStrategyRequest {
  assetClass: string | null;
  timeframe: string | null;
  symbols: string[];
  /** Scr.Enums.StrategyRequestPriority numbers, as the reference endpoint serves them. */
  mattersMost: number[];
  notes: string | null;
}

/**
 * The cap the server enforces, mirrored so the chips stop at it rather than the send failing. The
 * values themselves are not mirrored - they come from /api/reference/strategy-request-priorities,
 * which is backed by the same Scr.Enums list the write endpoint validates against.
 */
export const MAX_PRIORITIES = 2;
export const MAX_SYMBOLS = 10;
export const MAX_SHORT_ANSWER_LENGTH = 100;
export const MAX_NOTES_LENGTH = 1000;

export function useRequestStrategy() {
  return useMutation({
    mutationFn: async (request: RequestStrategyRequest) => {
      const response = await apiClient.post<{ requestId: string }>(
        "/trading-strategy-requests",
        request,
      );
      return response.data;
    },
  });
}
